import React from "react"
import classNames from "classnames"
import * as styles from "./Button.module.scss"
import { Link } from "../../Link"

type ButtonProps = {
	to?: string
	children: React.ReactNode
	className?: string
	variant?: "border" | "fill"
	size?: "default" | "small"
	noFill?: boolean
} & (
		| (React.ButtonHTMLAttributes<HTMLButtonElement> & { as?: "button" })
		| (React.AnchorHTMLAttributes<HTMLAnchorElement> & { as: "a" })
	)

const Button: React.FC<ButtonProps> = ({
	to,
	children,
	className,
	variant = "border",
	size = "default",
	noFill = false,
	as = "button",
	...props
}) => {
	const classes = classNames(
		styles.button,
		styles[variant],
		styles[size],
		{ [styles.noFill]: noFill },
		className
	)

	if (as === "a") {
		return (
			<a className={classes} {...(props as React.AnchorHTMLAttributes<HTMLAnchorElement>)}>
				{children}
			</a>
		)
	}

	const Element = to ? Link : "button"

	return (
		<Element className={classes} {...(props as React.ButtonHTMLAttributes<HTMLButtonElement>)} to={to}>
			{children}
		</Element>
	)
}

export default Button
